import { Routes } from '@angular/router';
import { faCommentsDollar, faFileInvoiceDollar, faReceipt } from '@fortawesome/pro-duotone-svg-icons';
import { genericResolver } from '@nittenapps/api';
import { dirtyGuard } from '@nittenapps/common';
import { NavItem } from '@nittenapps/components';

export const PROCESSING_ITEMS: NavItem[] = [
  {
    label: 'Trámite',
    icon: faCommentsDollar,
    iconSet: 'duo',
    roles: ['processing'],
    children: [
      {
        label: 'Registrar solicitud de pago',
        icon: faFileInvoiceDollar,
        iconSet: 'duo',
        roles: ['processing'],
        routerLink: ['processing', 'create-payment-request'],
      },
      {
        label: 'Registrar solicitud de pago de idemnización',
        icon: faReceipt,
        iconSet: 'duo',
        roles: ['processing'],
        routerLink: ['processing', 'create-payout-request'],
      },
    ],
  },
];

export const ROUTES: Routes = [
  {
    path: 'create-payment-request',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Registrar solicitud de pago',
      roles: ['processing'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./create-payment-request/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./create-payment-request/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.number || 'Nuevo'}` },
        },
      },
    ],
  },
  {
    path: 'create-payout-request',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Registrar solicitud de pago de idemnización',
      roles: ['processing'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./create-payout-request/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./create-payout-request/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.number || 'Nuevo'}` },
        },
      },
    ],
  },
];
